import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { WorkspaceProvider } from './context/WorkspaceContext';
import { UIProvider, useUI } from './context/UIContext';
import PrivateRoute from './components/PrivateRoute';
import TopBar from './components/TopBar';
import HamburgerMenu from './components/HamburgerMenu';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Vendors from './pages/Vendors';
import Personnel from './pages/Personnel';
import MyProfile from './pages/MyProfile';
import Venues from './pages/Venues';
import Projects from './pages/Projects';
import Events from './pages/Events';

function ProfileShell({ children }) {
  return (
    <>
      <TopBar hideHamburger={true} />
      {children}
    </>
  );
}

function AppShell({ children }) {
  const { isMenuOpen } = useUI();

  return (
    <>
      <TopBar />
      <div
        style={{
          paddingTop: '56px',
          display: 'flex',
          minHeight: '100vh',
        }}
      >
        <HamburgerMenu />
        <div
          style={{
            flex: 1,
            marginLeft: isMenuOpen ? '240px' : '0px',
            transition: 'margin-left 0.25s ease',
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <WorkspaceProvider>
      <UIProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <AppShell>
                  <Dashboard />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <AppShell>
                  <Clients />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/vendors"
            element={
              <PrivateRoute>
                <AppShell>
                  <Vendors />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/personnel"
            element={
              <PrivateRoute>
                <AppShell>
                  <Personnel />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/venues"
            element={
              <PrivateRoute>
                <AppShell>
                  <Venues />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <PrivateRoute>
                <AppShell>
                  <Projects />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/events"
            element={
              <PrivateRoute>
                <AppShell>
                  <Events />
                </AppShell>
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfileShell>
                  <MyProfile />
                </ProfileShell>
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      </UIProvider>
      </WorkspaceProvider>
    </AuthProvider>
  );
}
